import React, {useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import CustomTable from '../../../components/customTable/CustomTableRiks';
import {t} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';
import FilterRisk from '../riskHeader/RiskFilter';
import {deleteLitigationRisk} from '../../../services/deleteRisks';
import Prompt from '../../../components/prompt/prompt';
import Toast from '../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {Spin} from 'antd';

const ThirdTable = ({activeTab, user, departments, roles}) => {
  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const actionsRedirect = {
    editUrl: '/risks/edit',
    editTooltip: 'risk-cosideration.search.editRisk',
    deleteTooltip: 'risk-cosideration.search.deleteRisk',
  };

  const toEditRisk = (id) => {
    history.push({
      pathname: `/court-risk/${id}`,
      state: {isEditing: true},
    });
  };

  const toSingleRisk = (id) => {
    history.push(`/court-risk/${id}`);
  };
  const toSingleRiskRight = (id) => {
    window.open(`/court-risk/${id}`, '_blank');
  };
  const api = useRef();

  useEffect(() => {
    const arr = [];
    const arrQ = [];
    departments.map((item, idx) => {
      arrQ.push(item.id);
      arr.push({value: item.id, label: item.name});
    });
    api.current = `/court-risks?riskStatusId.equals=4&sort=id,desc`;
    setLoading(false);
  }, [departments]);

  const columnsThird = [
    {key: 'id', dataIndex: ['risk', 'id'], title: t('risk-cosideration.id')},
    {
      key: 'startingDateDispute',
      dataIndex: 'startingDateDispute',
      title: t('risk-cosideration.dateDispute'),
      ellipsis: true,
      render: (startingDateDispute) => {
        return (
          <span>{format(parseISO(startingDateDispute), 'dd.MM.yyyy.')}</span>
        );
      },
    },
    {
      key: 'bankLegitimation',
      dataIndex: 'bankLegitimation',
      title: t('risk-cosideration.bankLegitimation'),
      ellipsis: true,
    },
    {
      key: 'subjectDispute',
      dataIndex: 'subjectDispute',
      title: t('risk-cosideration.subjectDispute'),
      ellipsis: true,
    },
    {
      key: 'valueCourtDispute',
      dataIndex: 'valueCourtDispute',
      title: t('risk-cosideration.valueDispute'),
      ellipsis: true,
    },
    {
      key: 'jurisdiction',
      dataIndex: 'jurisdiction',
      title: t('risk-cosideration.jurisdiction'),
      ellipsis: true,
    },
    {
      key: 'provisionAmount',
      dataIndex: 'provisionAmount',
      title: t('risk-cosideration.provisionAmout'),
      ellipsis: true,
    },
    {
      key: 'feeReservation',
      dataIndex: 'feeReservation',
      title: t('risk-cosideration.feeReservation'),
      ellipsis: true,
    },
    {
      key: 'subjectStatus',
      dataIndex: 'subjectStatus',
      title: t('risk-cosideration.subjectStatus'),
      ellipsis: true,
    },
    {
      key: 'departmentSourceName',
      dataIndex: ['risk', 'departmentSourceName'],
      title: t('risk-cosideration.departmentSourceName'),
      ellipsis: true,
    },
    {
      key: 'value',
      title: t('last-potential-incurred.userCreated'),
      render: (request) => {
        return `${request.risk.userCreatedFirstName} ${request.risk.userCreatedLastName}`;
      },
    },
  ];

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRisk'),
        text: t('question.deleteRisk'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteLitigationRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('common.risk')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const filterSubmit = (data) => {
    const parameters = [];
    if (data.selectRisk?.value === 'id') {
      parameters.push(`id.equals=${data.searchInput}`);
    }
    if (data.selectRisk?.value === 'title') {
      parameters.push(`title.contains=${data.searchInput}`);
    }
    if (data.dateCreated) {
      parameters.push(
        `applicationDate.greaterThanOrEqual=${
          format(new Date(data.dateCreated), 'yyyy-MM-dd') +
          'T' +
          format(new Date(data.dateCreated), 'hh:mm:ss')
        }`
      );
    }
    if (data?.dateUpdated) {
      parameters.push(
        `applicationDate.lessThanOrEqual=${
          format(new Date(data.dateUpdated), 'yyyy-MM-dd') +
          'T' +
          format(new Date(data.dateUpdated), 'hh:mm:ss')
        }`
      );
    }
    if (data.selectRisk?.value === 'estimation') {
      parameters.push(`riskEstimationId.equals=${data.searchInput}`);
    }

    if (data.department) {
      let arr = [];
      data.department.length > 0 &&
        data.department.map((item, idx) => {
          arr.push(item.value);
        });
      if (arr.length > 0) {
        parameters.push(`departmentSourceId.in=${arr.join(',')}`);
      } else if (parameters.length > 0) {
        setQuery(
          'court-risks?riskStatusId.equals=4&sort=id,desc' + '&' + parameters.join('&')
        );
      } else {
        setQuery('court-risks?riskStatusId.equals=4&sort=id,desc');
      }
    } else if (data.department === null) {
      setQuery('court-risks?riskStatusId.equals=4&sort=id,desc');
    }

    if (parameters.find((p) => p.includes('departmentSourceId.in='))) {
      setQuery(
        'court-risks?riskStatusId.equals=4&sort=id,desc' + '&' + parameters.join('&')
      );
    }
  };

  return (
    <>
      {loading ? (
        <Spin spinning={loading} size={'large'} className="spinner" />
      ) : (
        <>
          <FilterRisk
            setQuery={setQuery}
            submit={filterSubmit}
            activeTab={activeTab}
            user={user}
            departments={departments}
          />
          <CustomTable
            api={query === undefined ? api.current : query}
            columns={columnsThird}
            className={'table-hover'}
            methods={{onDelete}}
            addButtonRef={{}}
            query={query}
            actionsRedirectResponsibleUser={actionsRedirect}
            onClickRow={toSingleRisk}
            onColumnEdit={toEditRisk}
            userId={user.id}
            roles={roles}
            departments={departments}
            onColumnRowRightClick={toSingleRiskRight}
          />
        </>
      )}
    </>
  );
};

export default ThirdTable;
